import { Types } from 'mongoose';
import { IAddress } from './order';
import { IAccount } from './account';

export interface IUser {
  _id: Types.ObjectId;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  /**
   * @deprecated This property has been superceded by the accounts property.
   */
  auth_level: AuthLevel;
  address?: IAddress;
  accounts?: IUserAccountMapping[];
  createdByAccount?: Types.ObjectId | IAccount;
  isEmployee: boolean;
  employeeRoles?: EmployeeRole[];
}

export interface IEditingUser extends IUser {
  roles: Role[];
}

export interface IUserAccountMapping {
  account_id: Types.ObjectId;
  roles: Role[];
  lastLogin?: Date;
}

/**
 * @deprecated This enum is no longer used, use the Role enum instead.
 */
export enum AuthLevel {
  User = 'user',
  Uploader = 'uploader',
  Admin = 'admin',
}

export enum Role {
  Uploader = 'uploader',
  Admin = 'admin',
  Owner = 'owner',
  LicenseManager = 'license_manager',
  Manager = 'manager',
}

export enum EmployeeRole {
  PicseeEmployee = 'picsee_employee',
  PicseeSupport = 'picsee_support',
  PicseeManager = 'picsee_manager',
  PicseeAdmin = 'picsee_admin',
}
